import { useTranslation } from 'react-i18next';
import { HelperText, Label, TextInput } from '@c2fo/liquidity';
import { PercentIcon } from '@c2fo/liquidity/icons';
import { RateType } from '../../OfferBuilderContext';
import { ValidateRateResult } from '../../utils';

interface NameYourRateInputProps {
  internalRate: string;
  internalRateType: RateType;
  onRateBlur: () => void;
  onRateChange: (value: string) => void;
  onRateTypeChange: (value: RateType) => void;
  rateError: ValidateRateResult | null;
  rateInputRef: React.RefObject<HTMLInputElement>;
  rateTypeError: string | null;
}

const NameYourRateInput = ({
  internalRate,
  internalRateType,
  onRateBlur,
  onRateChange,
  rateError,
  rateInputRef,
}: NameYourRateInputProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-3">
      <div className="flex flex-col gap-3 sm:flex-row">
        <div className="w-full space-y-1">
          <div className="w-72 space-y-1">
            <Label htmlFor="rate-input">{t('core.rate')}</Label>
            <div className="flex items-center gap-3">
              <TextInput
                ref={rateInputRef}
                id="rate-input"
                value={internalRate}
                onChange={(e) => onRateChange(e.target.value)}
                onBlur={onRateBlur}
                placeholder={t('taker.setARate')}
                className="w-full"
                endIcon={PercentIcon}
                hasError={rateError && !rateError.valid}
              />
              <div className="font-medium">{internalRateType}</div>
            </div>
          </div>
          {rateError && !rateError.valid && <HelperText variant="error">{rateError.errorMessage}</HelperText>}
        </div>
      </div>
    </div>
  );
};

export default NameYourRateInput;
